/**
 * Faixa da sugestão de vínculo NF × pedido, calculada no servidor (gaveta e pedidos elegíveis).
 * Ordem de exibição: 1 → 2 → 3; fora das faixas, o campo vem nulo.
 */
export enum FaixaSugestaoVinculoEnum {
  /** Mesmo fornecedor e pelo menos um produto em comum. */
  FornecedorEProduto = 1,
  /** Mesmo fornecedor, nenhum produto em comum. */
  SomenteFornecedor = 2,
  /** Produto em comum, fornecedor diferente. */
  SomenteProduto = 3,
}
